import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { Navigate } from 'react-router';

//-------------------- IMPORT MAIN PAGES --------------//
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const BrandPage = Loadable(lazy(() => import('pages/Brand')));
const ProductPage = Loadable(lazy(() => import('pages/Product')));
const OfferPage = Loadable(lazy(() => import('pages/Offer')));
const TestimonialPage = Loadable(lazy(() => import('pages/Testimonial')));
const ProfilePage = Loadable(lazy(() => import('pages/Profile')));

//---------------- IMPORT ALL FORMS -------------------------//
const BrandForm = Loadable(lazy(() => import("../sections/forms/BrandForm")));
const ProductForm = Loadable(lazy(() => import("../sections/forms/ProductForm")));
const OfferForm = Loadable(lazy(() => import("../sections/forms/OfferForm")));
const TestimonialForm = Loadable(lazy(() => import("../sections/forms/TestimonialForm")));

//-------------------- IMPORT ALL DETAILS PAGE -------------------//
const BrandDetailPage = Loadable(lazy(() => import("../sections/detail/BrandDetail")));
const ProductDetailPage = Loadable(lazy(() => import("../sections/detail/ProductDetail")));
const OfferDetailPage = Loadable(lazy(() => import("../sections/detail/OfferDetail")));
const TestimonialDetailPage = Loadable(lazy(() => import("../sections/detail/TestimonialDetail")));

const MainRoutes = {
  path: '/',
  children: [
    { index: true, element: <Navigate to="/login" replace /> },
    { path: 'login', element: <LoginPage /> },

    // ================= DASHBOARD LAYOUT PAGES =====================
    {
      element: <DashboardLayout />,
      children: [
        {
          index: true,
          path: 'dashboard',
          element: <DashboardDefault />
        },

        // ------------ BRANDS ------------
        {
          path: 'brands',
          children: [
            { index: true, element: <BrandPage /> },
            { path: 'create', element: <BrandForm /> },
            { path: 'update/:id', element: <BrandForm /> },
            { path: 'details/:id', element: <BrandDetailPage /> }
          ]
        },

        // ------------ PRODUCTS ------------
        {
          path: 'products',
          children: [
            { index: true, element: <ProductPage /> },
            { path: 'create', element: <ProductForm /> },
            { path: 'update/:id', element: <ProductForm /> },
            { path: 'details/:id', element: <ProductDetailPage /> },
          ]
        },

        //-------------- OFFER ----------------
        {
          path: 'offers',
          children: [
            { index: true, element: <OfferPage /> },
            { path: 'create', element: <OfferForm /> },
            { path: 'update/:id', element: <OfferForm /> },
            { path: 'details/:id', element: <OfferDetailPage /> },
          ]
        },

        // ------------ TESTIMONIAL ------------
        {
          path: 'testimonials',
          children: [
            { index: true, element: <TestimonialPage /> },
            { path: 'create', element: <TestimonialForm /> },
            { path: 'update/:id', element: <TestimonialForm /> },
            { path: 'details/:id', element: <TestimonialDetailPage /> }
          ]
        },

        // ------------ PROFILE ------------
        {
          path: 'profile',
          element: <ProfilePage />
        },
      ]
    }
  ]
};

export default MainRoutes;

